/** Видимые тексты контрола аккаунта — буквально из Figma. */
export const ACCOUNT_TEXTS = {
  loginLabel: 'Войти',
  hintTitle: 'В Личном кабинете вы сможете:',
  hintItems: [
    'Следить за изменением цен на интересные вам отели и направления',
    'Хранить всю историю заказов и документы по ним',
    'Копить скидку на следующие поездки',
    'Управлять настройками рассылок',
  ],
} as const;

/** Тексты мобильного экрана «Личный кабинет недоступен». */
export const APP_PROMO_TEXTS = {
  title: 'Личный кабинет',
  heading: 'Личный кабинет недоступен \n в мобильной версии',
  subtitle: 'Вы можете воспользоваться личным \n кабинетом в приложении',
  download: 'Скачать приложение',
  browser: 'Перейти на полную версию',
  chatAriaLabel: 'Написать в чат',
} as const;
